import { useGlobalContext } from "../../../../../../Context/Context";
import { useEffect, useState, useRef } from "react";
import axios from "axios";
import ReactDOM from "react-dom";
import keyImg from "../../../../../../picture/info-key-img.png";
import lockedImg from "../../../../../../picture/padlock-locked.png";
import unlockedImg from "../../../../../../picture/padlock-unlocked.png";
import deleteImg from "../../../../../../picture/delete.png";
import ButtonsPocetna from "./ButtonsPocetna";
import ButtonsEdit from "./ButtonsEdit";
import Button from "../../../../../Custom/Button/Button";
import ButtonsAddItem from "./ButtonsAddItem";
// import PrintSredstvo from "./PrintSredstvo";

const styles = {
  button: { padding: "5px 30px", fontWeight: "bold" },
  cell: { padding: "5px", textAlign: "center" },
  cellHeader: { padding: "5px", textAlign: "center", backgroundColor: "#ccc" },
  smallCell: { width: "40px", textAlign: "center" },
};

function PreviewSredstvo({ id, cancelPreview }) {
  const [data, setData] = useState(null);
  const [newData, setNewData] = useState(null);
  const [currentState, setCurrentState] = useState("");
  const [zaposleniAll, setZaposleniAll] = useState([]);

  const { dictionary, baseUrl, selectedMainEntity } = useGlobalContext();

  const fetchData = () => {
    if (!id || !selectedMainEntity?.company_id) return;
    axios
      .post(`${baseUrl}/spp/get_one.php`, {
        sredstvo_id: id,
        company_id: selectedMainEntity.company_id,
      })
      .then(({ data: res }) => {
        if (res.status === 200) {
          setData(res.data);
          setNewData(res.data);
        }
      })
      .catch(console.error);
  };

  useEffect(() => {
    fetchData();
  }, [id]);

  useEffect(() => {
    if (!selectedMainEntity?.company_id) return;
    axios
      .post(`${baseUrl}/evidencija6/get_lookups.php`, {
        company_id: selectedMainEntity.company_id,
      })
      .then(({ data: res }) => {
        if (res.status === 200) setZaposleniAll(res.zaposleni || []);
      })
      .catch(console.error);
  }, [selectedMainEntity]);

  const handlePovecajKom = (stavkaId) => {
    setNewData((prev) => ({
      ...prev,
      stavke: prev.stavke.map((s) =>
        s.id === stavkaId
          ? { ...s, kolicina_trenutna: Number(s.kolicina_trenutna) + 1 }
          : s,
      ),
    }));
  };

  const handleSmanjiKom = (stavkaId) => {
    setNewData((prev) => ({
      ...prev,
      stavke: prev.stavke.map((s) =>
        s.id === stavkaId && s.kolicina_trenutna > 0
          ? { ...s, kolicina_trenutna: Number(s.kolicina_trenutna) - 1 }
          : s,
      ),
    }));
  };

  const handleObrisiStavku = async (stavkaId) => {
    try {
      await axios.post(`${baseUrl}/spp/delete_stavka.php`, {
        stavka_id: stavkaId,
      });
      setNewData((prev) => ({
        ...prev,
        stavke: prev.stavke.filter((s) => s.id !== stavkaId),
      }));
    } catch (e) {
      console.error(e);
    }
  };

  if (!data || !newData) return null;

  const fotoUrl = newData.foto_path
    ? `${baseUrl.replace("/api", "")}/${newData.foto_path}`
    : null;

  const handlePrint = () => {
    const printWindow = window.open("", "_blank", "width=900,height=700");
    const html = `<!DOCTYPE html><html><head><title>Stampa</title>
      <style>
        * { margin: 0; padding: 0; box-sizing: border-box; }
        body { font-family: Arial, sans-serif; }
        @page { size: A4 portrait; margin: 0; }
        table { border-collapse: collapse; width: 100%; }
        td, th { border: 1px solid #999; padding: 6px 8px; font-size: 13px; text-align: center; }
        th { background-color: #ccc; font-weight: bold; }
        td.left { text-align: left; }
        .wrap { width: 210mm; height: 297mm; padding: 8mm; display: flex; align-items: flex-start; }
        .col-left { width: 48%; display: flex; flex-direction: column; max-height: 100%; }
        .col-right { width: 52%; height: 100%; }
        .foto-wrap { flex: 1; border: 1px solid #999; border-top: none; display: flex; align-items: center; justify-content: center; overflow: hidden; min-height: 0; }
        .foto-wrap img { width: 100%; height: 100%; object-fit: cover; display: block; padding: 30px 20px; }
        .no-foto { color: #aaa; font-size: 13px; }
        .yellow { background-color: #fff3cd; }
        .col-right table {  }
      </style></head><body>
      <div class="wrap">
        <div class="col-left">
          <table><tbody>
            <tr><th>Vrsta</th><th>Tip</th><th>Lokacija</th></tr>
            <tr><td>${newData.vrsta}</td><td>${newData.tip}</td><td>${newData.lokacija}</td></tr>
            <tr><th style="width:32px"></th><th>Odgovoran za stanje</th><th>Ističe</th></tr>
            <tr><td>${newData.stanje ? "🔒" : "🔓"}</td><td>${newData.odgovoran_naziv || ""}</td><td>${newData.datum_isteka || ""}</td></tr>
          </tbody></table>
          <div class="foto-wrap">
            ${fotoUrl ? `<img src="${fotoUrl}" />` : '<span class="no-foto">Nema fotografije</span>'}
          </div>
          <table><tbody>
            <tr><th colspan="3">Osposobljeni za prvu pomoć</th></tr>
            ${
              (newData.prvaPomoc || []).length > 0
                ? (newData.prvaPomoc || [])
                    .map(
                      (pp) =>
                        `<tr><td>${pp.tel || ""}</td><td>${pp.name || ""}</td><td>${pp.nivo || ""}</td></tr>`,
                    )
                    .join("")
                : `<tr><td colspan="3" style="color:#aaa">—</td></tr>`
            }
            ${[
              ["Najbliža služba hitne pomoći", newData.hitnaPomoc],
              ["Najbliža zdravstvena ustanova", newData.zdravstvenaUstanova],
              ["Najbliži centar za trovanja", newData.centarZaTrovanja],
              ["Najbliži centar za opekotine", newData.centarZaOpekotine],
              ["Najbliža policijska stanica", newData.policijska],
              ["Najbliža vatrogasna služba", newData.vatrogasna],
            ]
              .map(
                ([label, obj]) => `
              <tr><th colspan="3">${label}</th></tr>
              <tr><td>${obj?.tel || ""}</td><td colspan="2" class="left">${obj?.adresa || ""}</td></tr>
            `,
              )
              .join("")}
          </tbody></table>
        </div>
        <div class="col-right">
          <table><tbody>
            <tr><th style="width:32px">Rb.</th><th class="left">Sadržaj</th><th style="width:42px">Kom.</th></tr>
            ${(newData.stavke || [])
              .map(
                (s, i) => `
              <tr class="${s.kolicina_trenutna < s.kolicina_min ? "yellow" : ""}">
                <td>${i + 1}.</td>
                <td class="left">${s.naziv}</td>
                <td>${s.kolicina_trenutna}</td>
              </tr>
            `,
              )
              .join("")}
          </tbody></table>
        </div>
      </div>
      <script>window.onload = () => { window.print(); window.onafterprint = () => window.close(); }</script>
      </body></html>`;
    printWindow.document.write(html);
    printWindow.document.close();
  };

  return (
    <div style={{ height: "100%", display: "flex", flexDirection: "column" }}>
      <div
        style={{
          flex: 1,
          overflowY: "auto",
          display: "flex",
          background: "white",
          border: "1.5px solid #9f9f9f",
          padding: "10px",
        }}
      >
        {/* Leva kolona */}
        <div style={{ width: "50%" }}>
          <table style={{ width: "100%" }}>
            <tbody>
              <tr>
                <th style={styles.cellHeader}>{dictionary["vrsta"]}</th>
                <th style={styles.cellHeader}>{dictionary["tip"]}</th>
                <th style={styles.cellHeader}>{dictionary["lokacija"]}</th>
              </tr>
              <tr>
                <td style={styles.cell}>{newData.vrsta}</td>
                <td style={styles.cell}>{newData.tip}</td>
                <td style={styles.cell}>{newData.lokacija}</td>
              </tr>
            </tbody>
          </table>

          <table style={{ width: "100%" }}>
            <tbody>
              <tr>
                <th style={{ ...styles.smallCell, backgroundColor: "#ccc" }}>
                  <img src={keyImg} style={{ width: "30px" }} />
                </th>
                <th style={styles.cellHeader}>
                  {dictionary["odgovoranZaStanje"]}
                </th>
                <th style={styles.cellHeader}>{dictionary["istice"]}</th>
              </tr>
              <tr>
                <td style={styles.cell}>
                  <img
                    src={newData.stanje ? lockedImg : unlockedImg}
                    style={{ width: "15px" }}
                  />
                </td>
                <td style={styles.cell}>{newData.odgovoran_naziv}</td>
                <td style={styles.cell}>{newData.datum_isteka || ""}</td>
              </tr>
            </tbody>
          </table>

          <div
            style={{
              border: "1px solid black",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              minHeight: "300px",
            }}
          >
            {fotoUrl ? (
              <img src={fotoUrl} style={{ maxWidth: "100%" }} />
            ) : (
              <span>
                {dictionary["nepostojiFotografija"] || "Nema fotografije"}
              </span>
            )}
          </div>

          <table style={{ width: "100%" }}>
            <tbody>
              <tr>
                <th style={styles.cellHeader} colSpan={3}>
                  {dictionary["prvaPomocOsposobljeni"]}
                </th>
              </tr>
              {(newData.prvaPomoc || []).map((pp, i) => (
                <tr key={i}>
                  <td style={styles.cell}>{pp.tel}</td>
                  <td style={styles.cell}>{pp.name}</td>
                  <td style={styles.cell}>{pp.nivo}</td>
                </tr>
              ))}
              <tr>
                <th style={styles.cellHeader} colSpan={3}>
                  {dictionary["najblizaSluzbaHitnaPomoc"]}
                </th>
              </tr>
              <tr>
                <td style={styles.cell}>{newData.hitnaPomoc?.tel}</td>
                <td style={styles.cell} colSpan={2}>
                  {newData.hitnaPomoc?.adresa}
                </td>
              </tr>
              <tr>
                <th style={styles.cellHeader} colSpan={3}>
                  {dictionary["najblizaZdravstvenaUstanova"]}
                </th>
              </tr>
              <tr>
                <td style={styles.cell}>{newData.zdravstvenaUstanova?.tel}</td>
                <td style={styles.cell} colSpan={2}>
                  {newData.zdravstvenaUstanova?.adresa}
                </td>
              </tr>
              <tr>
                <th style={styles.cellHeader} colSpan={3}>
                  {dictionary["najbliziCentarZaTrovanja"]}
                </th>
              </tr>
              <tr>
                <td style={styles.cell}>{newData.centarZaTrovanja?.tel}</td>
                <td style={styles.cell} colSpan={2}>
                  {newData.centarZaTrovanja?.adresa}
                </td>
              </tr>
              <tr>
                <th style={styles.cellHeader} colSpan={3}>
                  {dictionary["najbliziCentarZaOpekotine"]}
                </th>
              </tr>
              <tr>
                <td style={styles.cell}>{newData.centarZaOpekotine?.tel}</td>
                <td style={styles.cell} colSpan={2}>
                  {newData.centarZaOpekotine?.adresa}
                </td>
              </tr>
              <tr>
                <th style={styles.cellHeader} colSpan={3}>
                  {dictionary["najblizaPolicijskaSt"]}
                </th>
              </tr>
              <tr>
                <td style={styles.cell}>{newData.policijska?.tel}</td>
                <td style={styles.cell} colSpan={2}>
                  {newData.policijska?.adresa}
                </td>
              </tr>
              <tr>
                <th style={styles.cellHeader} colSpan={3}>
                  {dictionary["najblizaVatrogasnaSl"]}
                </th>
              </tr>
              <tr>
                <td style={styles.cell}>{newData.vatrogasna?.tel}</td>
                <td style={styles.cell} colSpan={2}>
                  {newData.vatrogasna?.adresa}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Desna kolona — stavke */}
        <div style={{ width: "50%" }}>
          <table style={{ width: "100%" }}>
            <tbody>
              <tr>
                <th style={styles.cellHeader}>{dictionary["rb"]}</th>
                <th style={{ ...styles.cellHeader, width: "75%" }}>
                  {dictionary["sadrzaj"]}
                </th>
                <th style={styles.cellHeader}>{dictionary["kom"]}</th>
              </tr>
              {(newData.stavke || []).map((stavka, index) => (
                <tr
                  key={stavka.id}
                  style={{
                    backgroundColor:
                      stavka.kolicina_trenutna < stavka.kolicina_min
                        ? "#fff3cd"
                        : "transparent",
                  }}
                >
                  <td style={styles.cell}>{index + 1}.</td>
                  <td style={styles.cell}>{stavka.naziv}</td>
                  <td style={styles.cell}>
                    {currentState !== "EDIT" ? (
                      stavka.kolicina_trenutna
                    ) : (
                      <div
                        style={{
                          display: "flex",
                          gap: "2px",
                          justifyContent: "space-between",
                        }}
                      >
                        {stavka.custom && stavka.kolicina_trenutna === 0 ? (
                          <div onClick={() => handleObrisiStavku(stavka.id)}>
                            <Button activation={true}>
                              <img src={deleteImg} style={{ width: "25px" }} />
                            </Button>
                          </div>
                        ) : (
                          <div onClick={() => handleSmanjiKom(stavka.id)}>
                            <Button
                              activation={true}
                              style={{ padding: "0px 5px" }}
                            >
                              -
                            </Button>
                          </div>
                        )}
                        <div>{stavka.kolicina_trenutna}</div>
                        <div onClick={() => handlePovecajKom(stavka.id)}>
                          <Button
                            activation={true}
                            style={{ padding: "0px 3px" }}
                          >
                            +
                          </Button>
                        </div>
                      </div>
                    )}
                  </td>
                </tr>
              ))}
              {currentState === "EDIT" && (
                <tr>
                  <td colSpan={2}></td>
                  <td onClick={() => setCurrentState("ADD_ITEM")}>
                    <Button activation={true}>+</Button>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {currentState === "" && (
        <ButtonsPocetna
          cancelPreview={cancelPreview}
          setCurrentState={setCurrentState}
          onPrint={handlePrint}
        />
      )}
      {currentState === "EDIT" && (
        <ButtonsEdit
          setCurrentState={setCurrentState}
          newData={newData}
          setNewData={setNewData}
          data={data}
          setData={setData}
          zaposleniAll={zaposleniAll}
          onRefresh={fetchData}
        />
      )}
      {currentState === "ADD_ITEM" && (
        <ButtonsAddItem
          setCurrentState={setCurrentState}
          setNewData={setNewData}
          sredstvoId={data.id}
        />
      )}
    </div>
  );
}

export default PreviewSredstvo;
